<template>
  <div class="layout">
    <!-- 头部 -->
    <header :class="{ fixed: isFixed }">
      <nav>
        <div class="logo">
          <img :src="$getImageUrl('/index/b_logo.png')" alt="全域科技" />
        </div>
        <!-- 桌面端导航 -->
        <div class="nav-links desktop">
          <router-link to="/" exact>首页</router-link>
          <router-link to="/ServiceTenet">服务宗旨</router-link>
          <router-link to="/ServiceContent">服务内容</router-link>
          <router-link to="/ServiceSence">服务场景</router-link>
          <router-link to="/ServiceCase">服务案例</router-link>
          <router-link to="/Honor">荣誉资质</router-link>
          <router-link to="/About">关于我们</router-link>
        </div>
        <div class="contact">
          <img :src="$getImageUrl('/index/phone.png')" />
          <span>400-608-1806</span>
        </div>
      </nav>
    </header>
    <!-- 中间内容 -->
    <router-view />
    <!-- 底部 -->
    <footer>
      <div class="footer-content">
        <div class="footer-left">
          <div class="footer-nav">
            <div class="nav-top">
              <img
                :src="$getImageUrl('/index/header_logo.png')"
                alt="全域科技"
                class="footer-logo"
              />
              <div class="nav-item">
                <!-- <span class="project-name">全域资源实训平台</span> -->
                <a
                  href="https://www.qyskills.com/zysx/#/"
                  class="project-name border-right"
                  target="_blank"
                  >全域资源实训平台</a
                >
                <a
                  href="https://cis.qyskills.com/#/sso/login"
                  target="_blank"
                  class="project-name"
                  >全域CIS系统</a
                >
                <!-- <span style="cursor: pointer" @click="openCISSystem"
                  >全域CIS系统</span
                > -->
              </div>
            </div>
            <div class="nav-bottom">
              <div class="phone-remind">7*24小时服务热线</div>
              <div class="nav-item flex-between">
                <div class="phone-number">400-608-1806</div>
                <!-- <div class="flex-center">
                  <img
                    class="contact-icon"
                    :src="$getImageUrl('/index/contact.png')"
                    alt="电话"
                  />
                  <span @click="toAsk" class="color-fff">在线咨询</span>
                </div> -->
              </div>
            </div>
          </div>
          <div class="footer-nav-start">
            <div class="details">
              广州全域科技有限公司 版权所有 Copyright©2021 A Rights Reserved
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank"
                >粤ICP备2025491007号</a
              >
            </div>
            <div class="details">
              建议使用IE11及以上版本、Firefox、GoogleChrome浏览
            </div>
          </div>
        </div>
        <div class="footer-right">
          <div class="qr-codes">
            <div class="qr-item">
              <img :src="$getImageUrl('/index/gzh.jpg')" alt="扫码关注公众号" />
              <div>扫码关注公众号</div>
            </div>
            <div class="qr-item">
              <img :src="$getImageUrl('/index/wx.png')" alt="扫码联系负责人" />
              <div>扫码联系负责人</div>
            </div>
          </div>
          <div class="contact-person">
            <div class="remind">联系人</div>
            <div class="c_name">胡老师</div>
            <div class="remind">联系方式</div>
            <div class="c_phone">189-1181-9812</div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isFixed: false,
      isMobile: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.isFixed = scrollTop > 0;
    },
    // openCISSystem() {
    //   window.open("https://cis.qyskills.com/#/sso/login", "_blank");
    // },
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="less" scoped>
.layout {
  min-width: 75rem;
  header {
    //background: #eeeeee;
    background-color: #fff;
    height: 3.75rem;
    min-width: 75rem;
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
    &.fixed {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
    }
    nav {
      max-width: 75rem;
      margin: 0 auto;
      padding: 0 1.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo {
        img {
          height: 2rem;
        }
      }

      .nav-links {
        height: 100%;
        display: flex;
        align-items: center;

        a {
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0 1.5rem;
          text-decoration: none;
          color: #333;
          font-size: 1rem;
          font-weight: 500;

          &.router-link-active {
            background: #1890ff;
            color: #fff;
          }

          &:hover {
            background: rgba(24, 144, 255, 0.1);
            color: #333;
          }
        }
      }

      .contact {
        color: #666;
        font-size: 1.125rem;
        img {
          height: 1rem;
          margin-right: 0.5rem;
          vertical-align: -2px;
        }
      }
    }
  }
  footer {
    background-color: #2d3440;
    color: #fff;
    padding: 3.75rem 0 1.25rem;

    .footer-content {
      max-width: 75rem;
      margin: 0 auto;
      padding: 0 1.5rem;
      display: flex;
      > div {
        width: 50%;
      }
      .footer-left {
        .footer-logo {
          height: 2rem;
        }

        .footer-nav {
          display: flex;
          color: #8797a1;
          font-size: 1rem;
          flex-direction: column;
          width: 32rem;
          > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .nav-bottom {
            flex-direction: column;
            align-items: start;
            padding-top: 1rem;
            color: #8797a1;
            .nav-item {
              width: 100%;
            }
            .phone-remind {
              font-size: 0.875rem;
              padding-bottom: 0.25rem;
            }
            .phone-number {
              font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
              font-weight: 400;
              font-size: 28px;
              color: #ffffff;
            }
            .contact-icon {
              height: 1.75rem;
              width: 1.75rem;
              margin-right: 0.5rem;
            }
          }
          .nav-item {
            .project-name {
              padding-right: 1.25rem;
              margin-right: 1.25rem;
              text-decoration: none;
              color: #8797a1;
              &.border-right {
                border-right: 1px solid;
              }
            }
          }
        }
        .footer-nav-start {
          color: #8797a1;
          padding-top: 0.75rem;
          .details {
            padding-bottom: 0.5rem;
            font-size: 0.875rem;
            &:last-child {
              padding-bottom: 0;
            }
            a {
              color: inherit;
              text-decoration: none;
              cursor: pointer;
              &:hover {
                color: #1890ff;
              }
            }
          }
        }
      }

      .footer-right {
        display: flex;
        color: #8797a1;
        justify-content: flex-end;
        .contact-person {
          padding: 0.75rem;
          padding-left: 1rem;
          .remind {
            font-size: 0.875rem;
            padding-bottom: 3px;
          }
          .c_name,
          .c_phone {
            color: #fff;
          }
          .c_name {
            padding-bottom: 0.625rem;
          }
        }
        .qr-codes {
          display: flex;
          gap: 2rem;
          justify-content: flex-end;
          .qr-item {
            text-align: center;
            font-size: 0.875rem;
            img {
              width: 7.5rem;
              height: 7.5rem;
              margin-bottom: 0.25rem;
            }
            div {
              font-size: 0.875rem;
            }
          }
        }
      }
    }

    .footer-bottom {
      max-width: 75rem;
      margin: 2.5rem auto 0;
      padding: 1.25rem 1.5rem 0;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      text-align: center;

      p {
        color: rgba(255, 255, 255, 0.45);
        font-size: 0.875rem;
        line-height: 1.5;
      }
    }
  }
}
</style>
